import { memo, type ReactNode } from "react";

interface Props {
  icon?: string;
  title: string;
  badge?: string;
  subtitle?: string;
  extra?: ReactNode;
}

export const SectionLabel = memo(function SectionLabel({
  icon,
  title,
  badge,
  subtitle,
  extra,
}: Props) {
  return (
    <div className="flex items-center justify-between flex-shrink-0">
      <div className="flex items-center gap-2">
        {icon && (
          <img
            src={icon}
            alt=""
            className="w-[20px] h-[20px] 2560px:w-[26px] 2560px:h-[26px] object-contain flex-shrink-0"
          />
        )}
        <div className="flex flex-col leading-tight">
          <div className="flex items-center gap-2">
            <span className="text-[13px] 1440px:text-[15px] 1600px:text-[16px] 2560px:text-[20px] font-semibold uppercase text-white">
              {title}
            </span>
            {badge && (
              <span
                className="text-xs 2560px:text-sm font-bold uppercase"
                data-badge="section-badge"
              >
                {badge}
              </span>
            )}
          </div>
          {subtitle && (
            <span className="text-[10px] 1440px:text-[11px] 1600px:text-[12px] 2560px:text-[15px] text-white/50">
              {subtitle}
            </span>
          )}
        </div>
      </div>
      {extra && (
        <div className="text-[15px] 2560px:text-[18px] text-white !font-[400] bg-white/5 rounded-md px-6 py-1.5">
          {extra}
        </div>
      )}
    </div>
  );
});
